var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tune-chatbot" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "tune-header" }, [_vm._v("Tune your chatbot")]),
      _vm._v(" "),
      _c("div", { staticClass: "tune-desc" }, [
        _vm._v("Add final tweaks to achieve better results."),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "welcome-box tune-box" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "input-box input-welcome-text" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.clone.welcomeText,
                expression: "clone.welcomeText",
              },
            ],
            domProps: { value: _vm.clone.welcomeText },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.clone, "welcomeText", $event.target.value)
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "attributes-box tune-box" },
        [
          _vm._m(1),
          _vm._v(" "),
          _vm._l(_vm.fields, function (field) {
            return _c("div", { key: field.key, staticClass: "input-box" }, [
              _c("div", { staticClass: "title-box" }, [
                _vm._m(2, true),
                _vm._v(" "),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(field.label)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "value-box" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.clone.attributes[field.key],
                      expression: "clone.attributes[field.key]",
                    },
                  ],
                  attrs: { placeholder: "Attribute value" },
                  domProps: { value: _vm.clone.attributes[field.key] },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.clone.attributes,
                        field.key,
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ])
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "right" },
      [
        _c("ChatbotTunePreview", {
          attrs: {
            "company-name": _vm.clone.attributes.company_name,
            "welcome-text": _vm.clone.welcomeText,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tune-header" }, [
      _c("div", [_vm._v("Customize your welcome message")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tune-header" }, [
      _c("div", [_vm._v("Set up attributes")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "material-icons done" }, [_vm._v("check")]),
      _vm._v(" "),
      _c("i", { staticClass: "material-icons edit" }, [_vm._v("edit")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }